import React, { FC, memo, useState } from 'react';
import ErrorMessage from '../errorMessage';
import { validateEmail } from '~/src/utils/validateEmail';
import s from './index.module.scss';
import locales from '../../../../../../../../../../content.json';
import classNames from 'classnames';

type Props = {
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>, isValid: boolean) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement, Element>, isValid: boolean) => void;
  defaultValue?: string;
  className?: string;
  errorValidateText?: string;
};

const EmailField: FC<Props> = props => {
  const {
    className,
    placeholder = locales[window.userLang].enter_your_email,
    onChange,
    onBlur,
    defaultValue,
    errorValidateText = locales[window.userLang].payment_text_81,
  } = props;

  const [error, setError] = useState<string>();
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [hasValue, setHasValue] = useState<boolean>(!!defaultValue);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const isValid = validateEmail(value);

    setHasValue(value.length > 0);
    if (isValid) {
      setError('');
    }

    onChange?.(event, isValid);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement, Element>) => {
    const value = event.target.value;
    const isValid = validateEmail(value);

    setIsFocused(false);
    setHasValue(value.length > 0);

    if (!value) {
      setError('');
    } else if (!isValid) {
      setError(errorValidateText);
    }

    onBlur?.(event, isValid);
  };

  const showLabel = isFocused || hasValue;

  return (
    <>
      <div className={classNames(s.emailWrapper, showLabel && s.empty)}>
        {showLabel && (
          <span className={s.emailWrapper_title}>Email</span>
        )}
        <input
          className={classNames(s.email, error && s.error, className)}
          type="email"
          id="email"
          placeholder={placeholder}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          defaultValue={defaultValue}
        />
      </div>
      {/* {error && <ErrorMessage error={error} />} */}
      <ErrorMessage error={error} />
    </>
  );
};

export default memo(EmailField);
